import React from 'react'
import ProductOverview from '../Components/hospital/ProductOverview'
import CoreFeatures from '../Components/hospital/CoreFeatures'
import WhyChooseSection from '../Components/hospital/WhyChooseSection'
import CollaborateSection from '../Components/hospital/CollaborateSection'
import { Helmet } from "react-helmet-async";

function Hospital() {
    return (
        <div>
            <Helmet>
                <title>
                    Hospital Management System | Healthcare Software Solutions | Mobikode
                </title>

                <meta
                    name="description"
                    content="Simplify hospital operations with Mobikode's Hospital Management System. Manage patients, doctors, appointments, billing, pharmacy, administration, and healthcare workflows through a connected digital platform."
                />

                <meta
                    name="keywords"
                    content="Hospital Management System, Hospital Management Software, Hospital Software Solutions, Healthcare Management Software, Hospital ERP Software, Patient Management System, Doctor Management Software, Hospital Appointment Management, Hospital Billing Software, Pharmacy Management System, Healthcare IT Solutions, Digital Hospital Management, Hospital Administration Software, Healthcare Software Development, Hospital Workflow Automation"
                />

                <link
                    rel="canonical"
                    href="https://www.mobikode.com/hospital-management"
                />

                <meta
                    property="og:title"
                    content="Hospital Management System | Healthcare Software Solutions | Mobikode"
                />

                <meta
                    property="og:description"
                    content="Modernize hospital operations with Mobikode's integrated healthcare management solution for patient care, appointments, billing, pharmacy, doctors, and administration."
                />

                <meta
                    property="og:url"
                    content="https://www.mobikode.com/hospital-management"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                <meta
                    property="og:image"
                    content="https://www.mobikode.com/assets/hospital/bg1.png"
                />

                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="Hospital Management System | Healthcare Software Solutions | Mobikode"
                />

                <meta
                    name="twitter:description"
                    content="Manage patients, doctors, appointments, billing, pharmacy, and hospital administration with Mobikode's connected Hospital Management System."
                />

                <meta
                    name="twitter:image"
                    content="https://www.mobikode.com/assets/hospital/bg1.png"
                />
            </Helmet>
            <section className="relative w-full h-[500px] lg:h-[630px] flex items-center bg-[#000814] overflow-hidden py-12 md:py-0">
                <div className="absolute inset-0 z-0">
                    <img
                        src="/assets/hospital/bg1.png"
                        alt="Abstract 3D Background"
                        className="w-full h-full object-cover"
                    />
                    <div
                        style={{ background: "linear-gradient(86.84deg, #000000 20%, rgba(0, 0, 0, 0) 79%)" }}
                        className="hidden md:block absolute inset-0"
                    ></div>
                    <div
                        style={{ background: "linear-gradient(0deg, #000000 40%, rgba(0, 0, 0, 0.3) 100%)" }}
                        className="block md:hidden absolute inset-0"
                    ></div>
                </div>
                <div className="relative z-10 w-full max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px] flex flex-col items-start justify-center h-full">
                    <div className="w-full max-w-[500px] md:max-w-[700px] lg:max-w-[900px] mt-auto md:mt-0">
                        <h1 className="text-white font-[600] text-[28px] sm:text-[36px] md:text-[50px] lg:text-[60px] font-sora leading-[1.2] lg:leading-[1.1] mb-[12px] lg:mb-[22px] drop-shadow-xl tracking-wide text-left">
                            Hospital Management
                        </h1>
                        <p className="text-[#FFFFFF] max-w-[800px] w-full text-[14px] sm:text-[16px] md:text-[18px] leading-[20px] md:leading-[22px] lg:leading-[24px] font-graphik font-light tracking-wider text-left opacity-90 lg:opacity-100">
                            Managing a hospital means coordinating patients, doctors, appointments, billing, pharmacy, and administration. Handling this across disconnected systems creates inefficiencies, delays, and inconsistent data
                        </p>
                    </div>
                </div>
            </section>
            <ProductOverview />
            <CoreFeatures />
            <WhyChooseSection />
            <CollaborateSection />
        </div>
    )
}

export default Hospital
